(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ombre-new-watch-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ombre-new-watch-spotlight')) {
    class OmbreNewWatchSpotlight extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.gallery = this.querySelector('[data-spotlight-gallery]');
        this.slides = Array.from(this.querySelectorAll('[data-spotlight-slide]'));
        this.previousButton = this.querySelector('[data-spotlight-previous]');
        this.nextButton = this.querySelector('[data-spotlight-next]');
        this.variantInput = this.querySelector('[data-spotlight-variant-id]');
        this.priceOutput = this.querySelector('[data-spotlight-price]');
        this.availabilityOutput = this.querySelector('[data-spotlight-availability]');
        this.submitButton = this.querySelector('[data-spotlight-submit]');
        this.previousButton?.addEventListener('click', () => this.moveGallery(-1));
        this.nextButton?.addEventListener('click', () => this.moveGallery(1));
        this.querySelectorAll('[data-spotlight-variant]').forEach((radio) => {
          radio.addEventListener('change', () => {
            if (radio.checked) this.updateVariant(radio);
          });
        });
      }

      moveGallery(direction) {
        if (!this.gallery || this.slides.length < 2) return;
        const slideWidth = this.gallery.clientWidth;
        if (!slideWidth) return;
        const currentIndex = Math.round(this.gallery.scrollLeft / slideWidth);
        const nextIndex = (currentIndex + direction + this.slides.length) % this.slides.length;
        this.gallery.scrollTo({ left: nextIndex * slideWidth, behavior: 'smooth' });
      }

      updateVariant(radio) {
        const available = radio.dataset.variantAvailable === 'true';

        if (this.variantInput) {
          this.variantInput.value = radio.dataset.variantId;
          this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (this.priceOutput) {
          this.priceOutput.textContent = radio.dataset.variantPrice;
        }

            if (this.availabilityOutput) {
              this.availabilityOutput.dataset.available = String(available);
              this.availabilityOutput.textContent = available
            ? radio.dataset.availableLabel
            : radio.dataset.unavailableLabel;
        }

        if (this.submitButton) {
          this.submitButton.disabled = !available;
          this.submitButton.textContent = available
            ? radio.dataset.addLabel
            : radio.dataset.soldOutLabel;
        }
      }
    }

    customElements.define('ombre-new-watch-spotlight', OmbreNewWatchSpotlight);
  }

  } catch(e) { console.error(e); }
})();
})();
